export enum LeaseStepId {
  MANAGER_LEASE = 'mgr.lease',
}
